var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import VueGtag from 'vue-gtag';
import { BRow, BCol, BImg, BCard, BFormRadioGroup, BFormGroup, BButton, BFormInput } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash/debounce';
import MountboardColours from 'components/MountboardColours.vue';
import DiscountsBreakdown from 'components/DiscountsBreakdown.vue';
import MountVisualisation from 'components/materials/MountVisualisation.vue';
import MountKitSizeSelector from 'components/materials/MountKitSizeSelector.vue';
import MountKitDesignSelector from 'components/materials/MountKitDesignSelector.vue';
import { addToCart } from 'ts/modules/cart';
Vue.use(VueGtag, {
    config: { id: "UA-939335-4" }
});
let MountKits = class MountKits extends Vue {
    constructor() {
        super(...arguments);
        this.minPrice = '0.00';
        this.price = '1.00';
        this.totalPrice = '1.00';
        this.selectedBoard = null;
        this.quantity = 1;
        this.loading = true;
        this.priceBreakdown = {
            base_unit_price: "0.00",
            ex_vat_base_unit_price: "0.00",
            unit_price: "0.00",
            total_price: "0.00",
            unit_discount: "0.00",
            total_discount: "0.00"
        };
        this.selectedInitSize = {
            width: 148,
            length: 105,
            name: 'A6',
            type: 'a'
        };
        this.selectedSecSize = {
            width: 203,
            length: 152,
            name: '8" x 6"',
            type: 'inch'
        };
        this.initSizeType = 'artwork';
        this.initSizeTypeOptions = [
            { text: 'Artwork Size', value: 'artwork' },
            { text: 'Frame Size', value: 'frame' }
        ];
        this.debouncedGetPrice = debounce(this.getPrice, 350);
    }
    get externalSize() {
        if (this.initSizeType == 'frame') {
            return {
                width: Math.min(this.selectedInitSize.width, this.selectedInitSize.length),
                length: Math.max(this.selectedInitSize.width, this.selectedInitSize.length),
            };
        }
        return {
            width: Math.min(this.selectedSecSize.width, this.selectedSecSize.length),
            length: Math.max(this.selectedSecSize.width, this.selectedSecSize.length)
        };
    }
    get apertureSize() {
        if (this.initSizeType == 'frame') {
            return {
                width: Math.min(this.selectedSecSize.width, this.selectedSecSize.length) - 6,
                length: Math.max(this.selectedSecSize.width, this.selectedSecSize.length) - 6
            };
        }
        return {
            width: Math.min(this.selectedInitSize.width, this.selectedInitSize.length) - 6,
            length: Math.max(this.selectedInitSize.width, this.selectedInitSize.length) - 6
        };
    }
    get bespokeUrl() {
        let params = new URLSearchParams({
            extWidthMM: String(this.externalSize.width),
            extHeightMM: String(this.externalSize.length),
            apWidthMM: String(this.apertureSize.width),
            apHeightMM: String(this.apertureSize.length),
            incUndermount: "1"
        });
        return '/cut-to-size-picture-mounts/bespoke?' + params.toString();
    }
    get isQuantityValid() {
        return this.quantity > 0;
    }
    onDesignerReady() {
        this.getPrice();
        this.getMinPrice();
    }
    getPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.quantity <= 0) {
                return;
            }
            this.loading = true;
            let { data } = yield axios
                .get('/api/pricing/mountboard/mountKit', {
                params: {
                    sku: `MCTS-${this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001'}`,
                    width: this.externalSize.width,
                    length: this.externalSize.length,
                    quantity: this.quantity
                }
            });
            this.priceBreakdown = data;
            this.loading = false;
        });
    }
    getMinPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            let { data } = yield axios
                .get('/api/pricing/mountboard/mountKit', {
                params: {
                    sku: `MCTS-8001`,
                    width: this.externalSize.width,
                    length: this.externalSize.length,
                    quantity: 500
                }
            });
            this.minPrice = data.unit_price;
        });
    }
    get sizeString() {
        if (this.initSizeType == 'artwork') {
            return `${this.selectedSecSize.name} to fit ${this.selectedInitSize.name} Item`;
        }
        return `${this.selectedInitSize.name} to fit ${this.selectedSecSize.name} Item`;
    }
    get imageUrl() {
        let params = new URLSearchParams({
            width: String(this.externalSize.width),
            length: String(this.externalSize.length),
            apWidth: String(this.apertureSize.width),
            apLength: String(this.apertureSize.length),
            code: this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001'
        });
        return '/api/visualisations/mountboard?' + params.toString();
    }
    addToCart() {
        const item = {
            sku: `MK-${this.selectedBoard ? this.selectedBoard.stock_lookup_sku : '8001'}`,
            qty: this.quantity,
            price: this.priceBreakdown.ex_vat_base_unit_price,
            attributes: {
                "Size": this.sizeString,
                "External Size": `${this.externalSize.length}x${this.externalSize.width}mm`,
                "Aperture Size": `${this.apertureSize.length}x${this.apertureSize.width}mm`,
                "Undermount": 'Yes',
                "Image": this.imageUrl
            }
        };
        // Log the add to cart event
        this.$gtag.event('add_to_cart', {
            "items": [
                {
                    "id": item.sku,
                    "name": `${item.sku} - Mount Kit`,
                    "brand": "Brampton Framing",
                    "category": "Mount Kit",
                    "quantity": this.quantity.toString(),
                    "price": this.priceBreakdown.ex_vat_base_unit_price
                }
            ]
        });
        addToCart(item, false);
    }
};
__decorate([
    Watch('selectedBoard', { deep: true }),
    Watch('quantity')
], MountKits.prototype, "debouncedGetPrice", void 0);
MountKits = __decorate([
    Component({
        components: {
            BRow, BCol, BImg, BCard, BFormRadioGroup, BFormGroup, BButton, BFormInput,
            MountboardColours, DiscountsBreakdown, MountVisualisation, MountKitSizeSelector, MountKitDesignSelector
        }
    })
], MountKits);
export default MountKits;
